import { Directive, HostListener } from '@angular/core';

@Directive({
  selector: '[appAlphabetOnly]'
})
export class AlphabetOnlyDirective {

  @HostListener('input', ['$event']) onInput(event: KeyboardEvent): void {
    const input = event.target as HTMLInputElement;
    const regex = /^[a-zA-Z\s]*$/;

    if (!regex.test(input.value)) {
      input.value = input.value.replace(/[^a-zA-Z\s]/g, '');
    }
  }
}
